import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardInput: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardInput_dataBinding_panelTitle',
    helpId: '6e1cfae1-e1d3-41de-8768-0e3d2ac3c240',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardInputRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardInput_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardInput_dataBinding_placeholder_label',
          prop: 'placeholder',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardInput_dataBinding_value_label',
          prop: 'value',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardInput_dataBinding_tooltip_label',
          prop: 'tooltip',
          supportedFieldTypes: [FieldType.text, FieldType.richText],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
